module.exports = __webpack_public_path__ + "static/media/LGSmartLight__W.dd4d4731.ttf";